/* global axios */
import ApiClient from './ApiClient';

class Bookings extends ApiClient {
  constructor() {
    super('bookings', { accountScoped: true });
  }

  get({
    page = 1,
    bookingType = '',
    status = '',
    q = '',
    provider = '',
    ratePlan = '',
    station = '',
    dateFrom = '',
    dateTo = '',
    source = '',
    userId = '',
    oneWay = false,
  } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        booking_type: bookingType || undefined,
        status: status || undefined,
        q: q || undefined,
        provider: provider || undefined,
        rate_plan: ratePlan || undefined,
        station: station || undefined,
        date_from: dateFrom || undefined,
        date_to: dateTo || undefined,
        source: source || undefined,
        user_id: userId || undefined,
        one_way: oneWay ? 'true' : undefined,
      },
    });
  }

  filterOptions() {
    return axios.get(`${this.url}/filter_options`);
  }
}

export default new Bookings();
